import { FC } from 'react';

import { NavLogoTopbar } from '@/components/blocks/topbar/nav-logo-topbar';
import { NavMainTopbar } from '@/components/blocks/topbar/nav-main-topbar';
import { NavUserTopbar } from '@/components/blocks/topbar/nav-user-topbar';
import { cn } from '@/lib/utils';

interface AppTopbarProps {
  className?: string;
}
export const AppTopbar: FC<AppTopbarProps> = ({
  className,
}: AppTopbarProps) => (
  <header
    className={cn(
      'flex bg-background sticky top-0 z-50 h-[var(--app-topbar-height)] border-b px-4',
      className
    )}>
    <NavLogoTopbar />
    <NavMainTopbar />
    <NavUserTopbar />
  </header>
);
